import { render, staticRenderFns } from "./AlloCallState.vue?vue&type=template&id=18989ba8&scoped=true"
import script from "./AlloCallState.vue?vue&type=script&lang=js"
export * from "./AlloCallState.vue?vue&type=script&lang=js"
import style0 from "./AlloCallState.vue?vue&type=style&index=0&id=18989ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18989ba8",
  null
  
)

export default component.exports